var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
var sizes = {
  small: '25%',
  medium: '50%',
  large: '75%',
  full: '100%'
};
var Group = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: stretch;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: ", ";\n\n  & > :first-child {\n    border-radius: ", " 0 0 ", ";\n  }\n  & > :last-child {\n    border-radius: 0 ", " ", " 0;\n  }\n  & > :only-child {\n    border-radius: ", ";\n  }\n"], ["\n  align-items: stretch;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: ", ";\n\n  & > :first-child {\n    border-radius: ", " 0 0 ", ";\n  }\n  & > :last-child {\n    border-radius: 0 ", " ", " 0;\n  }\n  & > :only-child {\n    border-radius: ", ";\n  }\n"])), function (p) {
  return p.affordance ? sizes[p.affordance] : '100%';
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
});

var InputGroup = function InputGroup(_a) {
  var _b = _a.affordance,
      affordance = _b === void 0 ? 'full' : _b,
      children = _a.children,
      props = __rest(_a, ["affordance", "children"]);

  return React.createElement(Group, Object.assign({
    className: "input-group group-size-" + affordance,
    affordance: affordance
  }, props), children);
};

export default InputGroup;
var templateObject_1;